import $ from 'jquery';
import { fabric } from 'fabric';
import { hideAllMenus } from '~core/hideAllMenus';
import { modifyState } from '~src/state';
import { getImageSize } from '~src/sidebar';
import { getCanvasBaseZoom } from '~loader/loader-utils';
import { toggleSaveNavMenu } from '~core/navbar';
import { deselectObjects } from '~src/ui';
import Swal from 'sweetalert2';
import { FEATURES, isFeatureEnabled } from '~src/features';
import {
  initExpandCanvas,
  createBoundaryRect,
  stopExpand,
  execExpand,
  applyExpand,
} from '~core/expand';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getGlobalControlsManager } from '~core/customControls';
import { prepareImageForEditing } from '~core/image';
import { fadeOutAsync } from '~src/utils';
import { isPlaceholderEditing } from '~core/magicFrame';
import { checkAiCreditsBeforeUse } from '~core/aiCredits';

export default async function startExpand() {
  const allowUseExpand = await isFeatureEnabled(FEATURES.AI_USE_EXPAND, false);
  if (!allowUseExpand) {
    return;
  }

  // Check credits before entering the feature
  const hasCredits = await checkAiCreditsBeforeUse({
    featureName: 'Expand Scene',
    requiredCredits: 1,
  });

  if (!hasCredits) {
    return;
  }

  // Hide floating controls immediately to prevent flicker when transitioning
  try {
    const { getGlobalControlsManager } = require('~core/customControls');
    const cm = getGlobalControlsManager && getGlobalControlsManager();
    cm && cm.hideAllControls();
  } catch (e) {
    console.error('Failed hiding controls (expand pre-check)', e);
  }

  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  if (isPlaceholderEditing(selection)) {
    return;
  }

  Swal.fire({
    title: "Preparazione dell'ambiente di lavoro...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  await fadeOutAsync('#main-canvas-container');

  // Ensure sidebar opens before marking overlay active
  showSidebarTab('image-ai-expand');

  // Mark overlay active quickly after opening sidebar (prevents re-show of controls)
  try {
    const { modifyState } = require('~src/state');
    modifyState('isExpandActive', true);
  } catch (e) {
    console.error('Failed to set isExpandActive state', e);
  }

  // Hide floating controls while working on the separate expand canvas
  try {
    const cm = getGlobalControlsManager();
    cm && cm.hideAllControls();
  } catch (e) {
    console.error('Failed hiding controls (expand canvases)', e);
  }
  $('#expand-canvas-container').show();

  modifyState('expandSelection', selection);

  const imageUrl = await prepareImageForEditing(selection, false);
  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    return;
  }

  let size = await getImageSize(imageUrl);

  const canvasWidth = size.w + size.w;
  const canvasHeight = size.h + size.h;

  initExpandCanvas({
    width: canvasWidth,
    height: canvasHeight,
    backgroundColor: 'white',
  });

  $('#drawing-expand-canvas').fadeIn();
  const zoom = getCanvasBaseZoom(canvasWidth, canvasHeight);
  $('#canvas-zoom').css('transform', `scale(${zoom})`);

  $('#editor-zoom-controls').hide();
  $('#editor-menu-apply-ai-expand').prop('disabled', true);
  modifyState('stopKeyboardListener', true);
  modifyState('isExpandActive', true);

  showSidebarTab('image-ai-expand');
  hideAllMenus();
  deselectObjects();
  toggleSaveNavMenu();

  modifyState('expandCoordinates', {
    originalSize: [size.w, size.h],
    newSize: [size.w, size.h],
    imagePosition: [0, 0],
  });

  new fabric.Image.fromURL(
    imageUrl,
    (img) => {
      img.set({
        selectable: false,
        evented: false,
        crossOrigin: 'anonymous',
        id: 'expanded-image',
      });

      window.expandDrawingCanvas.add(img);
      window.expandDrawingCanvas.centerObject(img);

      const boundaryRect = createBoundaryRect(window.expandDrawingCanvas, img);
      window.expandDrawingCanvas.add(boundaryRect);
      window.expandDrawingCanvas.setActiveObject(boundaryRect);
      window.expandDrawingCanvas.requestRenderAll();

      Swal.close();
    },
    { crossOrigin: 'anonymous' }
  );

  $('body').off('click', '#editor-menu-abort-ai-expand');
  $('body').on('click', '#editor-menu-abort-ai-expand', () => {
    stopExpand();
  });

  $('body').off('click', '#editor-menu-exec-ai-expand');
  $('body').on('click', '#editor-menu-exec-ai-expand', () => {
    execExpand();
  });

  $('body').off('click', '#editor-menu-apply-ai-expand');
  $('body').on('click', '#editor-menu-apply-ai-expand', () => {
    applyExpand();
  });
}
